import { links, paths } from '@farmersdog/constants';
import type { LinkProps } from '@farmersdog/corgi-x';

type NavigationLink = LinkProps & {
  label: string;
};

export const navigationLinks: NavigationLink[] = [
  {
    href: paths.PATH_REVIEWS,
    label: 'Reviews',
  },
  {
    href: paths.PATH_ABOUT_US,
    label: 'About Us',
  },
  {
    href: paths.PATH_FAQ,
    label: 'FAQ',
  },
  {
    href: paths.PATH_LOGIN,
    label: 'Log In',
  },
  {
    href: paths.PATH_SIGNUP,
    label: 'Signup',
  },
  {
    href: `${links.LINK_DIGEST}/`,
    label: 'Digest',
    target: '_blank',
    rel: 'noopener noreferrer',
  },
  {
    href: paths.PATH_DIY,
    label: 'DIY',
  },
  {
    href: paths.PATH_CAREERS,
    label: 'Careers',
    target: '_blank',
    rel: 'noopener noreferrer',
  },
  {
    href: links.LINK_DIGEST_VET_PORTAL,
    label: 'Vet Portal',
    target: '_blank',
    rel: 'noopener noreferrer',
  },
  {
    href: paths.PATH_BREED,
    label: 'Breeds',
  },
];
